<template>
    <slot name="filter-field-range" v-bind="this"></slot>
</template>

<script>
export default {
    name: 'FilterFieldRange',
    methods: {
        handleOptionUpdate(updatedFilter) {
            this.$emit('update-option', updatedFilter);
        }
    }
};
</script>
